import { defineStore } from 'pinia';

export default defineStore({
  id: 'messages',
  state: () => ({
    message: '',
    error: '',
    registrationFull: false,
  }),
  getters: {
    getMessage(state) {
      return state.message;
    },
    getError(state) {
      return state.error;
    },
    hasMessage(state) {
      return state.message !== '';
    },
    hasError(state) {
      return state.error !== '';
    },
    isRegistrationFull(state) {
      return state.registrationFull;
    },
  },
  actions: {
    setMessage(message) {
      this.message = message;
    },
    setError(error) {
      this.error = error;
    },
    setRegistrationFull(full) {
      this.registrationFull = full;
    },

    createMessage(message) {
      this.setMessage(message);
    },
    createError(error) {
      this.setError(error);
    },
    createRegistrationFull() {
      this.setRegistrationFull(true);
    },
    clearMessage() {
      this.setMessage('');
    },
    clearError() {
      this.setError('');
    },
    clearRegistrationFull() {
      this.setRegistrationFull(false);
    },
  },
});
